import {connect} from 'react-redux';
import ErrorAlert from '../ui/ErrorAlert';
import {clearError} from "../../store/actions";

export const mapStateToProps = state => {
    return {
        errors: state.errors
    }
};

export const mapDispatchToProps = dispatch => {
    return {
        onClearError(index) {
            dispatch(
                clearError(index)
            );
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorAlert)